<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Claim Assignee Company"
      text="Edit Claim Assignee Company"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-autocomplete
                v-model="localClaimAssigneeCompany.company_uid"
                :items="[localClaimAssigneeCompany.company]"
                item-text="name"
                item-value="id"
                disabled
                filled
                label="Company"
                outlined
              />
            </v-col>

            <v-col cols="12">
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="localClaimAssigneeCompany.start_date"
                    label="Start date"
                    outlined
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localClaimAssigneeCompany.start_date"
                  no-title
                  :min="claimApprovalWorkflowBatch.start_date"
                  :max="localClaimAssigneeCompany.end_date"
                  @input="startDateMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col cols="12">
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="localClaimAssigneeCompany.end_date"
                    label="End date"
                    outlined
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>

                    <template v-slot:append>
                      <v-btn
                        v-if="localClaimAssigneeCompany.end_date != null && !claimApprovalWorkflowBatch.end_date"
                        class="mb-3"
                        icon
                        @click="clearEndDate"
                      >
                        <v-icon color="red">
                          mdi-close
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localClaimAssigneeCompany.end_date"
                  no-title
                  :min="localClaimAssigneeCompany.start_date"
                  :max="claimApprovalWorkflowBatch.end_date"
                  @input="endDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      claimAssigneeCompany: {
        type: Object,
        required: true,
      },
      claimApprovalWorkflowBatch: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        loading: false,
        progressing: false,
        localClaimAssigneeCompany: null,
        startDateMenu: false,
        endDateMenu: false,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.loading = true

        this.localClaimAssigneeCompany = { ...this.claimAssigneeCompany }

        this.loading = false
      },
    },
    methods: {
      clearEndDate () {
        this.localClaimAssigneeCompany.end_date = null
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 
        
            this.progressing = true
            
            this.$api.claimAssigneeCompanies().update(this.localClaimAssigneeCompany.id, this.prepareFormData())
              .then(res => {
                if (res.status === 200) {
                  this.$emit('updated')              
                  this.$snack({ message: 'Claim assignee company updated' })
                  this.dialog = false                 
                }
              })
              .catch(() => {
                this.$snack({
                  color: 'error',
                  message: 'Failed to update claim assignee company',
                })
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          start_date: this.localClaimAssigneeCompany.start_date,
          end_date: this.localClaimAssigneeCompany.end_date,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:4px
}
</style>
